import { Button, Flex, Modal, Typography } from '@iheartjane/reefer';

interface Props {
  onCancel: () => void;
  onReplaceCart: () => void;
}

export function ReplaceCartContents({ onCancel, onReplaceCart }: Props) {
  return (
    <Modal.Content>
      <Flex width="100%" flexDirection="column" alignItems="center">
        <Typography mb={12} variant="h1-semibold">
          Start new bag?
        </Typography>
        <Typography>
          Jane supports checkout from only one store at a time. Would you like
          to clear your existing bag and add the item from this new store?
        </Typography>
        <Flex flexDirection="column" gap={16} mt={24} width="100%">
          <Button
            branded
            full
            variant="primary"
            label="Add item"
            onClick={onReplaceCart}
          />
          <Button
            branded
            full
            variant="secondary"
            label="Cancel"
            onClick={onCancel}
          />
        </Flex>
      </Flex>
    </Modal.Content>
  );
}
